import { render, staticRenderFns } from "./VxDatatable.vue?vue&type=template&id=3b592132&"
import script from "./VxDatatable.vue?vue&type=script&lang=js&"
export * from "./VxDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports